import React, { useEffect, useState } from "react";
import { backend_routes } from "../../../common/links";
import MyLoadingIcon from "../../UI/loadingIcon/MyLoadingIcon";
import { useAxiosGetRefreshing, useAxiosDeleteRefreshing } from "../../../hooks/useAxios";
import MySelect from "../../UI/select/MySelect";
import Event from "../../event/Event";
import EventsUI from "./EventsUI";

const EventsPage = function () {
    const [legends, setLegends] = useState(new Map());
    const [isLegendsFulFilled, setIsLegendsFulFilled] = useState(false);

    const [fetchLegends, isLegendsLoading] = useAxiosGetRefreshing(
        async function (response) {
            valuesToMap(response.data.data.legends);
        }
    );

    const [events, setEvents] = useState([]);
    const [isEventsLoading, setIsEventsLoading] = useState(false);


    useEffect(() => {
    }, [events])

    useEffect(() => {
        fetchLegends(backend_routes.LEGENDS_LIST);
    }, [])


    var deletingId;

    const handleChildElementClick = (e, id) => {
        e.stopPropagation();
        deletingId = id;
        deleteEvent(backend_routes.EVENTS_DELETE + id);
    }

    const [deleteEvent, isDeleteSending] = useAxiosDeleteRefreshing(
        async function (response) {
            if (response.data.data === 204) {
                setEvents(events.filter(value => value.Id !== deletingId))
            }
        }
    );


    const eventChanging = function (changedEvent) {
        setEvents(events.map(
            item => item.Id === changedEvent.Id 
                ? {
                    Id: changedEvent.Id,
                    code: changedEvent.code,
                    start: changedEvent.start,
                    finish: changedEvent.finish
                }
            : item
        ));
    }

    const valuesToMap = function (values) {
        let map = new Map();
        for (const legend_item of values) {
            map.set(legend_item.code, legend_item.content);
        }
        setLegends(map);
        setIsLegendsFulFilled(true);
    }

    return (
        <div style={{ padding: "5px" }}>
            {isLegendsLoading || !isLegendsFulFilled
                ? <MyLoadingIcon />
                : <EventsUI setEventsCallback={setEvents} setIsEventsLoadingCallback={setIsEventsLoading} legendsMap={legends} legendSetCallback={(map) => setLegends(map)} eventPostCallback={(event) => setEvents([...events, event])}/>
            }
            <br />
            <br />
            {
            // isDeleteSending || 
            isEventsLoading
                ? <MyLoadingIcon />
                :
                <>{events.map(item => 
                    <Event 
                        key={"event_" + item.Id} 
                        event={item} legendsMap={legends}
                        eventChangingCallback={eventChanging}
                        >
                        <div className="deleteButton" onClick={(e) => handleChildElementClick(e, item.Id)}>Удалить</div>
                    </Event>
                )}</>
            }
        </div>
    );
}
export default EventsPage;